import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
class AwLogoComponent {
    constructor() {
        this.logoClicked = new EventEmitter();
    }
    set logoHeight(_value) {
        console.warn('logoHeight in aw-logo is deprecated and will removed in the future release');
    }
    onLogoClick() {
        this.logoClicked.emit();
    }
}
AwLogoComponent.ɵfac = function AwLogoComponent_Factory(t) { return new (t || AwLogoComponent)(); };
AwLogoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwLogoComponent, selectors: [["aw-logo"]], inputs: { logoHeight: "logoHeight", logoUrl: "logoUrl", styleClasses: "styleClasses", logoAlt: "logoAlt", tabindex: ["data-tabindex", "tabindex"], awAriaLabel: ["aw-aria-label", "awAriaLabel"] }, outputs: { logoClicked: "logoClicked" }, decls: 4, vars: 5, consts: [[1, "logo-ratio"], ["href", "javascript:void(0)", 1, "logo-ratio-box", 3, "ngClass", "click"], ["automation", "logoComponent", 3, "src"]], template: function AwLogoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "a", 1);
        ɵngcc0.ɵɵlistener("click", function AwLogoComponent_Template_a_click_1_listener() { return ctx.onLogoClick(); });
        ɵngcc0.ɵɵelementStart(2, "span");
        ɵngcc0.ɵɵelement(3, "img", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.styleClasses);
        ɵngcc0.ɵɵattribute("tabindex", ctx.tabindex)("aria-label", ctx.awAriaLabel || null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵattribute("alt", ctx.awAriaLabel ? "" : ctx.logoAlt);
    } }, directives: [ɵngcc1.NgClass], styles: [".logo-ratio[_ngcontent-%COMP%]{max-width:270px}.logo-ratio[_ngcontent-%COMP%]   .logo-ratio-box[_ngcontent-%COMP%]{display:block;max-height:100%;max-width:100%;padding-bottom:20%;position:relative}.logo-ratio[_ngcontent-%COMP%]   .logo-ratio-box.logo-left[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{-ms-flex-pack:start;justify-content:flex-start}.logo-ratio[_ngcontent-%COMP%]   .logo-ratio-box.logo-right[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{-ms-flex-pack:end;justify-content:flex-end}.logo-ratio[_ngcontent-%COMP%]   .logo-ratio-box.logo-center[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{-ms-flex-pack:center;justify-content:center}.logo-ratio[_ngcontent-%COMP%]   .logo-ratio-box[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{-ms-flex-align:center;align-items:center;bottom:0;display:-ms-flexbox;display:flex;height:100%;left:0;position:absolute;right:0;top:0;width:100%}.logo-ratio[_ngcontent-%COMP%]   .logo-ratio-box[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-height:100%;max-width:100%}"] });
AwLogoComponent.propDecorators = {
    logoUrl: [{ type: Input }],
    styleClasses: [{ type: Input }],
    logoHeight: [{ type: Input }],
    logoAlt: [{ type: Input }],
    tabindex: [{ type: Input, args: ['data-tabindex',] }],
    awAriaLabel: [{ type: Input, args: ['aw-aria-label',] }],
    logoClicked: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwLogoComponent, [{
        type: Component,
        args: [{
                selector: 'aw-logo',
                template: "<div class=\"logo-ratio\">\n    <a\n        class=\"logo-ratio-box\"\n        [ngClass]=\"styleClasses\"\n        [attr.tabindex]=\"tabindex\"\n        [attr.aria-label]=\"awAriaLabel || null\"\n        href=\"javascript:void(0)\"\n        (click)=\"onLogoClick()\">\n        <span>\n            <img src=\"{{logoUrl}}\" [attr.alt]=\"awAriaLabel ? '' : logoAlt\" automation=\"logoComponent\">\n        </span>\n    </a>\n</div>\n\n",
                styles: [".logo-ratio{max-width:270px}.logo-ratio .logo-ratio-box{display:block;max-height:100%;max-width:100%;padding-bottom:20%;position:relative}.logo-ratio .logo-ratio-box.logo-left span{-ms-flex-pack:start;justify-content:flex-start}.logo-ratio .logo-ratio-box.logo-right span{-ms-flex-pack:end;justify-content:flex-end}.logo-ratio .logo-ratio-box.logo-center span{-ms-flex-pack:center;justify-content:center}.logo-ratio .logo-ratio-box span{-ms-flex-align:center;align-items:center;bottom:0;display:-ms-flexbox;display:flex;height:100%;left:0;position:absolute;right:0;top:0;width:100%}.logo-ratio .logo-ratio-box span img{max-height:100%;max-width:100%}"]
            }]
    }], function () { return []; }, { logoClicked: [{
            type: Output
        }], logoHeight: [{
            type: Input
        }], logoUrl: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }], logoAlt: [{
            type: Input
        }], tabindex: [{
            type: Input,
            args: ['data-tabindex']
        }], awAriaLabel: [{
            type: Input,
            args: ['aw-aria-label']
        }] }); })();

class AwLogoModule {
}
AwLogoModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwLogoModule });
AwLogoModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwLogoModule_Factory(t) { return new (t || AwLogoModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwLogoModule, { declarations: function () { return [AwLogoComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AwLogoComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwLogoModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AwLogoComponent
                ],
                exports: [
                    AwLogoComponent
                ]
            }]
    }], null, null); })();

export { AwLogoComponent, AwLogoModule };

//# sourceMappingURL=aw-ads-components-aw-logo.js.map